import React, { useState } from "react";
import { Button } from "reactstrap";
import "./PreAssessmentChatbotConversation.scss";
import AnvyImage from "@workspace/main/src/assets/images/Anvy 1.png";
import { BotAvatar } from "@workspace/common";

import { v4 as uuidv4 } from "uuid";

const PreAssessmentChatbotConversation = ({
  conversations = [],
  setPreAssessmentData,
  onNextQuestion,
  isLoading,
}) => {
  const [selectedQuestion, setSelectedQuestion] = useState([]);

  const getLastCOnversationWithQuestions = () => {
    // Reverse the conversation array
    const reversedConversations = [...conversations].reverse();
    // Check for the first bot conversation that has questions
    const lastConversationIndex = reversedConversations.findIndex(
      (conversation) =>
        conversation?.type === "bot" &&
        conversation?.data?.questions &&
        conversation?.data?.questions.length > 0
    );

    // Get the bot conversation and the human conversation after it(since we reversed the array)
    return [
      reversedConversations[lastConversationIndex + 1],
      reversedConversations[lastConversationIndex],
    ];
  };

  const generateStringFormatConversation = (conversations) => {
    const lastConversation = getLastCOnversationWithQuestions();
    return lastConversation
      .map((conversation) => {
        if (conversation?.type === "bot") {
          if (conversation?.data?.questions) {
            return `Bot: ${
              conversation?.message
            } \n ${conversation?.data?.questions
              .map((question, index) => `${index + 1}) ${question?.question}`)
              .join("\n")}`;
          }
        } else {
          return `Human: ${conversation?.message}`;
        }
      })
      .join("\n");
  };

  const generateConversation = (conversation, index) => {
    const alignment =
      conversation?.type === "human"
        ? "justify-content-end"
        : "justify-content-start";

    return !conversation?.hide ? (
      <div className={`row mb-3 ${alignment}`} key={index}>
        <div className="col-auto">
          {conversation?.message && !conversation?.hide && (
            <>
              {conversation?.type === "bot" ? (
                <div className="d-flex gap-2">
                  <BotAvatar avatarImg={AnvyImage} size="35px" />
                  <div className={`chatbot-conversation__${conversation.type}`}>
                    {conversation?.message}
                  </div>
                </div>
              ) : (
                <div className={`chatbot-conversation__${conversation.type}`}>
                  {conversation?.message}
                </div>
              )}
            </>
          )}
          <div className="mt-2">
            {conversation?.data?.questions &&
              conversation?.data?.questions.length > 0 &&
              conversation?.data?.questions?.map((question, index) => (
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  {selectedQuestion.includes(question) && (
                    <i
                      className="ri-checkbox-circle-line"
                      style={{
                        position: "absolute",
                        top: "1px",
                        right: "3px",
                        color: "#12A35D",
                      }}
                    ></i>
                  )}
                  <div
                    className="p-2 mt-2 cursor-pointer"
                    style={{
                      backgroundColor: "#FFFFFF",
                      borderRadius: "5px",
                      border: `2px solid ${
                        selectedQuestion.includes(question)
                          ? "#12A35D"
                          : "#e5e5e5"
                      }`,
                    }}
                    key={index}
                    onClick={() => {
                      if (selectedQuestion.includes(question)) {
                        setSelectedQuestion((prev) =>
                          prev.filter((item) => item !== question)
                        );
                      } else {
                        setSelectedQuestion((prev) => [...prev, question]);

                        setPreAssessmentData((prev) => ({
                          ...prev,
                          questions: [
                            ...prev.questions,
                            {
                              id: uuidv4(),
                              question,
                            },
                          ],
                        }));
                      }
                    }}
                  >
                    {`Q${index + 1}. ${question}`}
                  </div>
                </div>
              ))}
          </div>
          {(conversation?.message && !conversation?.hide) ||
          (conversation?.data?.questions &&
            conversation?.data?.questions.length > 0) ? (
            <div className={`chatbot-label d-flex ${alignment} px-2`}>
              <span>
                {conversation?.type.charAt(0).toUpperCase() +
                  conversation?.type.slice(1)}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    ) : null;
  };

  return (
    <>
      {conversations &&
        conversations.length > 0 &&
        conversations.map((conversation, index) =>
          generateConversation(conversation, index)
        )}
      {isLoading && <div class="dot-loader mb-3"></div>}
      <div className="d-flex align-items-center justify-content-between">
        <span
          style={{
            color: "#0063B5",
          }}
        >
          Finish
        </span>
        <Button
          style={{
            backgroundColor: "#0063B5",
            color: "#FFFFFF",
          }}
          onClick={() =>
            onNextQuestion(
              `
              Previous Conversation:
              <START OF CONVERSATION>
                ${JSON.stringify(
                  generateStringFormatConversation(conversations)
                )}
              <END OF CONVERSATION>
              Give me 2 more questions based on the last questions type in the chat history.`
            )
          }
        >
          Next Question
        </Button>
      </div>
    </>
  );
};

export default PreAssessmentChatbotConversation;
